const components = {
  // SDoc
  rmDocTip: 'Do you want to delete this file? Once deleted it cannot be restored.',
  searchPlaceholder: 'Search files or folders',
  upload: 'Upload',
  newFolder: 'New Folder',
  folderNamePlaceholder: 'Please enter folder name',
  cannotMoveToChild: 'Cannot move to subfolder',
  moveSuccess: 'Moved successfully',
  moveFail: 'Move failed',
  moveToParent: 'Move to parent',
  move: 'Move',
  moveTitle: 'Move',
  moving: 'Moving: {{name}}',
  currentLocation: 'Current location',
  rootDirectory: 'Root',
  noFolders: 'No folders',
  moveToHere: 'Move here',
  cancel: 'Cancel',

  // Dict
  plDictName: "Please enter a name",
  plDictDesc: "Please enter a description",
  dictName: 'Name',
  dictDesc: 'Description',

  // Selector
  plCountry: "Please select a country/region",
  plCreditLevel: "Please select a credit rating",
  plCurrency: "Please select a currency",
  plProduct: "Please select a product",

  // 详情弹窗
  plContent: 'Please enter the content',
  send: 'Send',
  reply: 'Reply',
  replyTo: 'Reply to {{name}}',
  cancelReply: 'Cancel reply',
  replyCount: '{{name}} replies',
  collapseReplies: 'Hide replies',
  cameraUpload: "Take Photo & Upload",
  takePhoto: "Take Photo",
  switchCamera: "Switch Camera",
};

export default components;
